import { ISearchPredictorResult } from "./ISearchPredictorResult";


export abstract class SearchTypeaheadBase {
           
    constructor(
        protected _searchBox: JQuery<HTMLElement>
    ) {
       
    }  
    

    protected initialiseTypeahead = (url: string): void => {       
        // need to kill any pre-existing suggestions        
        this._searchBox.typeahead("destroy");

        this._searchBox.typeahead({
            displayText: function (item: any) {
                let e = <ISearchPredictorResult>item;
                return `${e.searchString} (${e.searchResultsCount})`;
            },
            minLength: 2,
            delay: 1,
            items: 100,
            source: function (query, process) {
                $.ajax({
                    url: url,
                    data: { query: query },
                    dataType: 'json'
                }).done(function (response) {
                    return process(response);
                });
            },
            autoSelect: false,
            changeInputOnSelect: false,
            afterSelect: function (item) {
                let e = <ISearchPredictorResult>item;
                this.$element.val(`${e.searchString}`);
            }
        });
    }
}